var _circle, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgVerified(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 44,
    viewBox: "0 0 44 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 22,
    cy: 22,
    r: 22,
    fill: "#E8EEFF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.7327 22.4106L20.5776 25.2204L26.2672 19.6008M33.3793 22.4106C33.3793 28.678 25.6129 33.2195 22.9123 34.6094C22.6203 34.7597 22.4742 34.8349 22.2717 34.8738C22.1138 34.9041 21.8862 34.9041 21.7283 34.8738C21.5257 34.8349 21.3797 34.7597 21.0876 34.6094C18.387 33.2195 10.6207 28.678 10.6207 22.4106V17.0967C10.6207 15.9735 10.6207 15.4119 10.8067 14.9291C10.971 14.5026 11.238 14.1221 11.5846 13.8204C11.9769 13.4789 12.5093 13.2817 13.5742 12.8873L21.2009 10.0625C21.4966 9.95298 21.6444 9.89822 21.7966 9.8765C21.9314 9.85725 22.0685 9.85725 22.2034 9.8765C22.3556 9.89822 22.5034 9.95298 22.7991 10.0625L30.4258 12.8873C31.4906 13.2817 32.023 13.4789 32.4153 13.8204C32.762 14.1221 33.0289 14.5026 33.1932 14.9291C33.3793 15.4119 33.3793 15.9735 33.3793 17.0967V22.4106Z",
    stroke: "#0F4BFF",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVerified);
export default __webpack_public_path__ + "static/media/verified.6690a83d02a38e8de27a6640c89d8302.svg";
export { ForwardRef as ReactComponent };